import React from "react"
import _ from "lodash"

export default function Error(EM) {
  return function Error({error}) {
    // My handwritten error keys
    if (_.isString(error)) {
      return <EM id={error} />
    }
    // Errors returned from the Firebase server
    if (error.code && error.message) {
      return <EM id={error.code} defaultMessage={error.message} />
    }
    // Who knows?
    return <pre>{JSON.stringify(error, null, 2)}</pre>
  }
}



// WEBPACK FOOTER //
// ./src/auth-signin/Error.js